import { showErrorNotify } from "@/helpers/notify";

export default function (instance) {
  return {
    getItemsBySearchQuery(payload) {
      return instance
        .post("api/search", payload)
        .catch((error) => showErrorNotify(error));
    },
  };
}
